import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "envelope" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 4.5,
			width: 22.5,
			height: 15,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.687,
			y1: 9.975,
			x2: 19.5,
			y2: 13.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.313,
			y1: 9.975,
			x2: 4.5,
			y2: 13.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.88,5.014l-9.513,6.56a2.406,2.406,0,0,1-2.734,0L1.12,5.014"
		})
	]
});
export default SvgEnvelope;
